const url = {
    login: "/client/clientLogin",
    // getAllShifts: "/client/getAllExamShift",
    getAllShifts: "/client/getAllLiveExamShift",
    getVerificationEnums: "/client/getVerificationEnums",
    sendOtp:'/client/send-otp',
    verifyOtp:'/client/verify-otp',


    stats: {
        getCountInfo: "/client/countInfo",
        getVerificationWiseCount: "/client/countInfo/verification",
        getInvigilatorStats: "/client/stats",
        getVerifiedCount: "/client/verifiedCountUsers",
        getVerificationCountStats: "/client/getVerificationCountStats",
        getVerificationByState: "/client/getVerificationByState",
        getOperatorStats: "/client/inv/stats/data",
        // getVerifiedUserCount: "client/verifiedCountUsers",
    },

    client: {
        getVerificationData: "/client/getVerification",
        getUniqueCity: "/client/uniqueCities",
        getUniqueState: "/client/uniqueStates",
        getUniquesZone: "/client/uniqueZones",
        getUniqueCenter: "/client/uniqueCenters",
        getUniqueCenter2: "/client/dropdown/center/name",
        getUsers: "/client/getUsers",
        getUserData: "/client/getUsersData",
        downloadVerifiedZip: "/client/verifiedZip",
        searchByRollNo: "/client/user/search",
        getDatabyUserId: "/client/getDatabyUserId",
        getCenterCount: "/client/centerCount",
        getCenterStats: "/client/centerStats",
        centerStatsDetails: "/client/centerStatsDetails",
        getAllCSRReport: "/client/CSRReports",
        getAllBypassData: "/client/user/bypass",
        getDropdownData: "/client/dropdown",
        getInvigilators: "/client/invigilators",
        getStatsByStateData: "/client/dashboard/stats/state",
        getCityStatsTime: "/client/dashboard/stats/time/city",
        getStatsByCityData: "/client/dashboard/stats/city",

        getVerificationTrends: "/client/stats/verification/trends",
        getCityDetails: "/client/dashboard/stats/time/center",

        downloadShiftReport: "/client/export/shift/csv",
        downloadShiftVerificationData: "/client/export/verfications",
        getShiftRequestData: "/client/export/requests",
        updateRequestCount: "/client/export/update-count",

        getExceptionReport: "/client/exception/get",
        invigilatorsData: "/client/invigilators/login/logs",
        getAttendanceReport: "/client/attendance",
        operatorStats: "/client/inv/stats/center",
        downloadNotStarted: "/client/csv/inv/not-login",
        getVenueWiseAttendanceStats: "/client/venue/attendance",
        getFacialMismatchData: "/client/facial/match/mismatch",
        getVerificationV2: "/client/verification/get",
        getAttendanceStats:"/client/attendance-stats",
        getInvigilatorDetails: "/client/operator/detail/get",
        syncPages: "/client/sync-pages",
        allowedPages: "/client/allowed-pages",

        getAllUsersReverifications: "/client/reverification/all",
        getAllStreams: "/client/reverification/streams",
        donwloadReverificationCSV: '/client/reverification/csv',
        getReverificationStudentsData: "/client/reverification/student/get/college",
        getCollegeStatsData:"/client/reverification/stats/colleges/count",
        getVerificationsWithException:'/client/facial/exceptions/get',
        acceptFacialException:'/client/facial/exceptions',
        rejectFacialException:'/client/facial/exceptions/verified',
    },

    dropdown: {
        getZones: '/client/dropdown/zones',
        getStates: '/client/dropdown/states',
        getCities: '/client/dropdown/district',
        getCenters: '/client/dropdown/center',
        getUniqueCourses: '/client/dropdown-courses'

    },

    reverification:{
        getColleges:"/client/reverification/colleges",
        getStats:"/client/reverification/stats",
        getCollegeStats:"/client/reverification/stats/colleges",
    },
    v2: {
        getOperatorStats: "/client/inv/stats/data",
        operatorStats: "/client/inv/stats/center",
        getVerificationData:"/client/getVerification",
    }

};

export default url;
